import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const RevistaCeara: React.FC = () => (
  <div
    style={{
      minHeight: '100vh',
      background: '#000',
      color: '#fff',
      fontFamily: "'Inter', Arial, Helvetica, sans-serif",
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <Header />
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        maxWidth: 700,
        margin: '0 auto',
        padding: '48px 16px 0 16px'
      }}
    >
      {/* Instagram logo */}
      <img
        src="/images/logo/app_instagram_logo_media_popular_icon.png"
        alt="Instagram"
        style={{
          width: 48,
          height: 48,
          borderRadius: 12,
          marginBottom: 24
        }}
      />

      {/* Instagram post mockup */}
      <img
        src="/images/accor/PostRevistaCeara.png"
        alt="Post da Revista Ceará sobre lixo na COP 30"
        style={{
          width: '100%',
          maxWidth: 520,
          borderRadius: 24,
          boxShadow: '0 4px 32px rgba(0,0,0,0.4)',
          marginBottom: 32
        }}
      />

      {/* Matéria */}
      <h1 style={{ fontSize: '2.2rem', fontWeight: 700, marginBottom: 16, color: '#fff' }}>
        O lixo que ninguém quer ver na COP 30
      </h1>
      <p style={{ fontSize: '1.25rem', lineHeight: 1.7, marginBottom: 24, color: '#e0e0e0' }}>
        A poucos meses da COP 30, um dos maiores eventos globais sobre meio ambiente, cenas como a da imagem acima escancaram o descaso com a gestão do lixo em diversas regiões do Brasil. O flagrante, publicado no perfil oficial da Revista Ceará no Instagram, mostra a dura realidade de catadores em meio a toneladas de resíduos em um lixão a céu aberto no Pará.
      </p>
      <p style={{ fontSize: '1.15rem', lineHeight: 1.7, marginBottom: 24, color: '#ccc' }}>
        Enquanto líderes mundiais se preparam para discutir soluções sustentáveis, comunidades locais seguem enfrentando diariamente os impactos do acúmulo de lixo, falta de infraestrutura e políticas públicas ineficazes. O contraste entre o discurso ambiental e a realidade vivida por milhares de brasileiros evidencia a urgência de ações concretas e imediatas.
      </p>
      <p style={{ fontSize: '1.15rem', lineHeight: 1.7, marginBottom: 32, color: '#ccc' }}>
        Segundo especialistas, a gestão inadequada dos resíduos sólidos não só compromete o meio ambiente, mas também a saúde e a dignidade de quem depende do lixo para sobreviver. A expectativa é que a COP 30 traga à tona debates e compromissos que possam transformar esse cenário, promovendo inclusão social e sustentabilidade.
      </p>
      <div style={{ fontSize: '1rem', color: '#aaa', marginBottom: 8 }}>
        Veja mais em nosso Instagram:&nbsp;
        <a
          href="https://instagram.com/revistaceara"
          target="_blank"
          rel="noopener"
          style={{ color: '#00e0ff', textDecoration: 'underline' }}
        >
          @revistaceara
        </a>
      </div>
    </div>
    <Footer />
  </div>
);

export default RevistaCeara;